import React, { useState } from 'react';
import LeadsComponent from '../Component/LeadsComponent';
import ModalLeadContainer from './ModalLeadContainer';
import { useQuery } from '@tanstack/react-query';
import { getLeadsListAPI } from '../../../Services/leads.api';
import moment from 'moment';
import { IResultLeadsListDAO } from '../DAO/leads.dao';
import { Button } from 'antd';

export default function LeadsContainer() {
  const [selectedData, setSelectedData] = useState<IResultLeadsListDAO>();
  const [selectedFilter, setSelectedFilter] = useState<string[]>([
    moment().format('MM-01-YYYY'),
    moment().format('MM-DD-YYYY'),
  ]);

  const {
    data: leadList,
    isFetching,
    refetch,
  } = useQuery(
    ['getLeadList', selectedFilter[0], selectedFilter[1]],
    getLeadsListAPI,
    {
      refetchOnWindowFocus: false,
      enabled: selectedFilter.length !== 0,
    },
  );

  const handleSearch = (values: any) => {
    const { date } = values;
    if (!date || date === null) return;
    const startDate = moment(date[0]).format('MM-DD-YYYY');
    const endDate = moment(date[1]).format('MM-DD-YYYY');
    setSelectedFilter([startDate, endDate]);
  };

  const handleCancel = () => {
    setSelectedData(undefined);
    refetch();
  };

  const renderAction = (row: any) => {
    const rows = row.row.original;
    return (
      <Button
        type="text"
        onClick={() => setSelectedData(rows)}
        className="colorLightNavy"
      >
        Detail
      </Button>
    );
  };

  const columnData = [
    {
      Header: 'No. KTP',
      accessor: 'idNumber',
    },
    {
      Header: 'Nama Leads',
      accessor: 'name',
    },
    {
      Header: 'Agen Perekrut',
      accessor: row => {
        return `${row.refAgentCode} - ${row.refAgentName}`;
      },
    },
    {
      Header: 'Tanggal Input',
      accessor: row => {
        return moment(row.insertDate).format('DD-MMM-YYYY');
      },
    },
    {
      Header: 'Source',
      accessor: row => {
        return row.recSource === 0 ? 'MZA' : 'Link';
      },
    },
    {
      Header: 'Action',
      Cell: row => renderAction(row),
    },
  ];

  return (
    <>
      <LeadsComponent
        columnData={columnData}
        dataLeads={leadList || []}
        isLoading={isFetching}
        handleSearch={handleSearch}
      />
      {selectedData && (
        <ModalLeadContainer
          handleCancel={handleCancel}
          selectedData={selectedData}
        />
      )}
    </>
  );
}
